import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './api'
import './plugins'
import './utils/helpers'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import './components'

// non-core packages
import * as VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import IdleVue from 'idle-vue'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Carousel3d from 'vue-carousel-3d'

// WYSIWYG editor
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'

import JsonCsv from 'vue-json-csv'
import * as VueGoogleMaps from 'vue2-google-maps'

sync(store, router)

function changeFavicon (icon) {
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = icon
}

const org = process.env.VUE_APP_ORG

if (org === 'todd') {
  changeFavicon('katimas.png')
} else {
  changeFavicon('rex.png')
}

Vue.use(VueTheMask)
Vue.use(Viewer)
Vue.use(Carousel3d)
Vue.use(JsonCsv)
Vue.use(VeeValidate, { 
  events: 'input|blur',
  inject: false, 
})
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  store: store,
  idleTime: 1200000,
  startAtIdle: false,
})

Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
  })
  return formatter.format(value)
})

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.use(TiptapVuetifyPlugin, {
  vuetify, // same as "vuetify: vuetify"
  iconsGroup: 'md',
})

Vue.use(VueGoogleMaps, {
  load: 
  {
    key: 'AIzaSyCdnyWg9C4vvfw6YAjyasELkFUqXya8huA',
    libraries: 'geometry,places',
  },
  installComponents: true,
})

new Vue({
  router,
  store,
  vuetify,
  simplebar,
  render: h => h(App),
}).$mount('#app')
